import React, { useContext } from 'react'
import { TextField } from "@mui/material"
import { LoadingContext } from '../M_Utils'

export function M_TextArea({ label, value, required, disabled, color, secondColor, rows, helperText, onChange, disabledBorderColor }) {

    const ctx = useContext(LoadingContext)
    color = color || ctx.primaryColor || 'var(--color-black)'
    secondColor = secondColor || ctx.secondaryColor || 'var(--color-black)'



    return (<TextField
        sx={{
            '& label': { color: 'var(--color-black)', fontWeight: 'bold' },
            '& label.Mui-focused': { color: 'var(--color-black)' },
            '& .MuiInput-underline:after': { borderBottomColor: color },
            "& .MuiInputBase-root.Mui-disabled": {
                "& > fieldset": {
                    borderColor: 'rgba(0, 0, 0, 0.38) !important'
                }
            },
            '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    borderColor: disabled ? disabledBorderColor : 'rgba(0, 0, 0, 0.38) !important'
                },
                '&:hover fieldset': {
                    borderColor: disabled ? disabledBorderColor : 'rgba(0, 0, 0, 0.38) !important'
                },
                '&.Mui-focused fieldset': {
                    borderColor: disabled ? disabledBorderColor : 'rgba(0, 0, 0, 0.38) !important'
                },
                // "& legend": {
                //     letterSpacing: -1.9
                // }
            }
        }}
        margin="dense"
        required={required}
        disabled={disabled}
        fullWidth
        variant="outlined"
        InputLabelProps={{ autoComplete: "none", shrink: true }}
        label={label}
        value={value}
        onChange={onChange}
        multiline
        rows={rows ? rows : 3}
        helperText={helperText}
    />
    )
}